// Avoid importing anything outside of the main project
import {C8ImageSize} from '@utils';
import {CustomAttributeDefinition} from '@api/graphql';
import _ from 'lodash'
import * as lockr from 'lockr'
import config from '../config'
import {moment} from '@api'

const UNASSIGNED          = 'Unassigned'
const customAttributeType = {
  Int:     'intVal',
  Float:   'floatVal',
  Boolean: 'boolVal',
  String:  'strVal',
  TagList: 'tagList',
  Tag:     'tag',
  DateTime: 'dateTimeVal'
}

const getAttributeValue = (attributeDef, productAttributes) => 'Dead Code'

export const buildImageUrl = (imageWrapper, size : C8ImageSize = null, accessToken = null) => {
  let imageUrl
  if (imageWrapper && imageWrapper.length) {
    imageWrapper = _.find(imageWrapper, wrapper => wrapper.position === 0)
  }

  if (imageWrapper) {
    if (size && !imageWrapper.image[size]) {
      size = 'thumbnailImage'
      if (!imageWrapper[size]) {
        size = 'image'
        if (!imageWrapper[size]) {
          return null
        }
      }
    }

    const imageEndpoint = imageWrapper.image[size || 'thumbnailImage']
    imageUrl            = imageWrapper ? `${config.graphqlEndpoint}images/${imageEndpoint}?token=${accessToken ? accessToken : lockr.get('access_token')}` : undefined
  }
  return imageUrl
}


export class ProductDataWorker {
  static convertToSynthetic(product, cardViewData, attributeDefinitions: {[key: string]: CustomAttributeDefinition} = null, specImageSize: C8ImageSize = 'thumbnailImage', token = null, isVLPView = false) {
    const showProductInfo = (cardViewData && cardViewData.product_info) || (cardViewData && _.isUndefined(cardViewData.product_info))
    const showStyle       = (cardViewData && cardViewData.style) || (cardViewData && _.isUndefined(cardViewData.style))
    const showColor       = (cardViewData && cardViewData.color) || (cardViewData && _.isUndefined(cardViewData.color))
    const showMaterial    = (cardViewData && cardViewData.material) || (cardViewData && _.isUndefined(cardViewData.material))
    const showHardware    = (cardViewData && cardViewData.hardware) || (cardViewData && _.isUndefined(cardViewData.style))
    const showTags        = (cardViewData && cardViewData.tags) || (cardViewData && _.isUndefined(cardViewData.tags))
    const tags: any = showTags && !isVLPView ? _.filter(product.colorway && product.colorway.attributes, {name: 'Tags'})[0] : _.filter(product && product.attributes, {name: 'MerchOptionVersionTags'})[0];
    let data: any = {}
    if (!isVLPView) {
      data = {
        id:               product.id,
        colorway:         {
          ...product.colorway
        },
        images:           product.colorway && product.colorway.images.length ? [buildImageUrl(product.colorway.images, 'smallImage', token)] : [],
        imagesRaw:        product.colorway && product.colorway.images,
        active:           product.colorway && product.colorway.active,
        materials:        {
          isVisible: showMaterial
        },
        styles: {
          isVisible: showStyle
        },
        colors:           {
          isVisible: showColor
        },
        hardware:         {
          isVisible: showHardware
        },
        tags:             _.isEmpty(tags) ? [] : _.sortBy(tags.tagList, (tag) => _.toLower(tag.name)),
        isAttributes:     showTags,
        isComments:       product.colorway && product.colorway.comments && product.colorway.comments.comments && product.colorway.comments.comments.length > 0,
        customAttributes: {},
        //sketch: product.sketch
      }

      if (attributeDefinitions) {
        _.map(attributeDefinitions, (attr) => {
          let attrValue = getAttributeValue(attr, product.colorway && product.colorway.attributes)
          let name      = attr.name
          let isVisible = (cardViewData && cardViewData[name]) || (cardViewData && _.isUndefined(cardViewData[name]))
          if (isVisible) {
            data.customAttributes[name] = {
              isVisible:   (cardViewData && cardViewData[name]) || (cardViewData && _.isUndefined(cardViewData[name])),
              value:       !_.isUndefined(attrValue) && !_.isNull(attrValue) && attrValue.toLocaleString() || (attrValue == '' ? attrValue : '--'),
              displayName: attr.displayName && attr.displayName.singular,
              name:        attr.name,
              type:        attr.type,
              id:          `${product.id}_${attr.name}`
            }
          }
        })
      }
      if (showProductInfo) {
        data['title']     = product.name
        data['subtitle1'] = product.description || '--'
      }
      if (product.mainMaterials) {
        switch (product.mainMaterials.length) {
          case 2:
            _.forEach(product.mainMaterials, (material) => {
              data[material.type.name === 'Fabric' ? 'materials' : 'hardware'] = {
                id:         material.id,
                title:      _.trim(material.name) || '--',
                subtitle:   _.trim(material.description) || '--',
                exId:       material.exId,
                images:     material.images && material.images.length ? [buildImageUrl(material.images, specImageSize, token)] : [],
                imagesRaw:  material.images,
                type:       material.type,
                __typename: material.__typename,
                blank:      false,
                ...data[material.type.name === 'Fabric' ? 'materials' : 'hardware']
              }
            })
            break
          case 1:
            _.forEach(product.mainMaterials, (material) => {
              data[material.type.name === 'Fabric' ? 'materials' : 'hardware'] = {
                id:         material.id,
                title:      _.trim(material.name) || '--',
                subtitle:   _.trim(material.description) || '--',
                exId:       material.exId,
                images:     material.images && material.images.length ? [buildImageUrl(material.images, specImageSize, token)] : [],
                imagesRaw:  material.images,
                type:       material.type,
                __typename: material.__typename,
                blank:      false,
                ...data[material.type.name === 'Fabric' ? 'materials' : 'hardware']
              }
              data[material.type.name !== 'Fabric' ? 'materials' : 'hardware'] = {
                id:    material.type.name !== 'Fabric' ? `materials_${product.id}` : `hardware_${product.id}`,
                title: '--',
                blank: true,
                ...data[material.type.name !== 'Fabric' ? 'materials' : 'hardware']
              }
            })
            break
          case 0:
            data.materials = {
              id:    `materials_${product.id}`,
              title: '--',
              blank: true,
              ...data.materials
            }
            data.hardware  = {
              id:    `hardware_${product.id}`,
              title: '--',
              blank: true,
              ...data.hardware
            }
            break
          default:
        }
      }
      data.colors = {
        id:         product.color ? product.color.id : `color_${product.id}`,
        blank:      !product.color,
        title:      product.color ? product.color.name : '--',
        subtitle:   product.color ? _.trim(product.color.description) : '--',
        hex:        product.color ? _.trim(product.color.hex) : '',
        exId:       product.color ? product.color.exId : '',
        images:     product.color && product.color.images && product.color.images.length ? [buildImageUrl(product.color.images, specImageSize, token)] : [],
        imagesRaw:  product.color && product.color.images,
        __typename: product.color ? product.color.__typename : '',
        ...data.colors
      }
      data.styles = {
        id:         product.sketch ? product.sketch.id : `style_${product.id}`,
        blank:      !product.sketch,
        title:      product.sketch ? product.sketch.name : '--',
        subtitle:   product.sketch ? _.trim(product.sketch.description) : '--',
        exId:       product.sketch ? product.sketch.exId : '',
        images:     product.sketch && product.sketch.images && product.sketch.images.length ? [buildImageUrl(product.sketch.images, specImageSize, token)] : [],
        imagesRaw:  product.sketch && product.sketch.images,
        __typename: product.sketch ? product.sketch.__typename : '',
        ...data.styles
      }
    }
    return data
  }
}


// WEBPACK FOOTER //
// ./src/webWorkers/ProductDataWorker.ts